import * as React from "react";
import {
  OverviewTitle,
  OverviewTitleWrapper,
} from "../../../components/Details/OverviewInfo/styles";
import {
  DetailInnerWrapper,
  DetailPageBox,
} from "../../../components/sharedStyles";
import ServiceContractTable from "src/components/Tables/ServiceContracts/FullTable";

import { buildQueryString } from "../../../store/base";
import useActiveFilters from "../../../hooks/useActiveFilters";
import { PERSISTANT_CATEGORY_KEY } from "./ServiceContracts";

export default function ServiceContractDrafts() {
  const { filteredRealEstates } = useActiveFilters();

  const [readyToRenderTable, setReadyToRenderTable] = React.useState(false);
  const [selectedFilters, setSelectedFilters] = React.useState([]);
  const [persistantCategories, setPersistantCategories] = React.useState(null);

  const draftPersistantQueryString = buildQueryString({
    realestate__in: filteredRealEstates,

    draft: true,
  });
  const draftPersistantFilterMethod = (obj) => {
    if (!filteredRealEstates) return obj.draft === true;
    return (
      filteredRealEstates.includes(obj.realestate?.id) && obj.draft === true
    );
  };

  React.useEffect(() => {
    const persistantCategories = localStorage.getItem(PERSISTANT_CATEGORY_KEY);
    const parsed = persistantCategories ? JSON.parse(persistantCategories) : [];

    setSelectedFilters(parsed);

    if (parsed?.length) {
      setPersistantCategories(parsed);
    }
    setReadyToRenderTable(true);
  }, []);

  const handleClearPersistantCategories = () => {
    setSelectedFilters([]);
    setPersistantCategories(null);
    localStorage.removeItem(PERSISTANT_CATEGORY_KEY);
  };

  return (
    <>
      <DetailInnerWrapper>
        <DetailPageBox>
          <OverviewTitleWrapper>
            <OverviewTitle>Utkast</OverviewTitle>
          </OverviewTitleWrapper>

          {readyToRenderTable && (
            <ServiceContractTable
              persistantQueryString={draftPersistantQueryString}
              persistantFilterMethod={draftPersistantFilterMethod}
              hideTitle
              withPersistantSortBy
              withPersistantGlobalFilter
              persistantCategories={persistantCategories}
              clearCategories={() => setSelectedFilters([])}
              clearCategories={handleClearPersistantCategories}
            />
          )}
        </DetailPageBox>
      </DetailInnerWrapper>
    </>
  );
}
